import React, { useMemo, useState } from "react";
import { Modal, Button, Spinner } from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import Loader from "./Loader"; // Ensure the path is correct

const FileViewer = ({ file, onClose }) => {
  const [loading, setLoading] = useState(true);
  const [zoom, setZoom] = useState(1);

  // Normalize file to string if it's an array
  const fileUrl = useMemo(() => {
    if (Array.isArray(file)) {
      return file[0] || "";
    }
    return file || "";
  }, [file]);

  const fileName = useMemo(() => {
    try {
      if (!fileUrl) return "file";
      return decodeURIComponent(fileUrl.split("/").pop() || "file");
    } catch {
      return "file";
    }
  }, [fileUrl]);

  const extension = useMemo(() => fileName.split(".").pop()?.toLowerCase(), [fileName]);

  const isImage = ["jpg", "jpeg", "png", "webp", "gif"].includes(extension || "");
  const isPdf = extension === "pdf";
  const isOfficeDoc = ["doc", "docx", "xls", "xlsx"].includes(extension || "");

  const previewUrl = useMemo(() => {
    if (!fileUrl) return "";
    if (isOfficeDoc || isPdf) {
      return `https://docs.google.com/gview?url=${encodeURIComponent(fileUrl)}&embedded=true`;
    }
    return fileUrl;
  }, [fileUrl, isOfficeDoc, isPdf]);

  return (
    <Modal show={true} onHide={onClose} size="lg" centered backdrop="static">
      <Modal.Header closeButton>
        {/* <Modal.Title>{fileName}</Modal.Title> */}
      </Modal.Header>
      <Modal.Body style={{ minHeight: "400px", display: "flex", flexDirection: "column" }}>
        {isImage && (
          <div className="d-flex gap-2 mb-3 justify-content-center">
            <Button variant="outline-secondary" size="sm" onClick={() => setZoom(z => Math.min(z + 0.2, 3))}>
              <Icon.ZoomIn className="me-1" /> Zoom +
            </Button>
            <Button variant="outline-secondary" size="sm" onClick={() => setZoom(z => Math.max(z - 0.2, 0.5))}>
              <Icon.ZoomOut className="me-1" /> Zoom -
            </Button>
            <Button variant="outline-secondary" size="sm" onClick={() => setZoom(1)}>
              <Icon.ArrowClockwise className="me-1" /> Reset
            </Button>
          </div>
        )}

        <div 
          className="position-relative flex-grow-1 w-full border rounded overflow-auto bg-light d-flex align-items-center justify-content-center"
          style={{ minHeight: "350px" }}
        >
          {loading && (
            <div className="position-absolute top-50 start-50 translate-middle">
              <Spinner animation="border" variant="primary" />
            </div>
          )}
          
          {isImage ? (
            <img
              src={fileUrl}
              alt={fileName}
              style={{ 
                transform: `scale(${zoom})`, 
                transition: "transform 0.2s",
                maxWidth: "100%",
                maxHeight: "65vh",
                objectFit: "contain"
              }}
              onLoad={() => setLoading(false)}
            />
          ) : (isPdf || isOfficeDoc) ? (
            <iframe
              src={previewUrl}
              title={fileName}
              className="w-100"
              style={{ height: "65vh", border: "0" }}
              onLoad={() => setLoading(false)}
            />
          ) : (
            <div className="p-5 text-muted">Preview not available.</div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default FileViewer;